import { CSSProperties, FC, ReactElement } from "react";
import ReactModal from "react-modal";

interface Props {
  isOpen: boolean;
  style?: CSSProperties;
  children: ReactElement | ReactElement[];
}

export const Modal: FC<Props> = ({ isOpen, style, children }) => {
  const modalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "300px",
      ...style,
    },
  };

  return (
    <ReactModal isOpen={isOpen} style={modalStyles} ariaHideApp={false}>
      {children}
    </ReactModal>
  );
};
